import { MoodStrip } from '../mood/MoodStrip';
import type { MoodId } from '../mood/moods';
import { SupportPrompt } from '../support/SupportPrompt';
import { RightNow, offersSupport, type RightNowState } from './RightNow';

export interface HubHeroProps {
  mood: MoodId | null;
  onMoodChange: (mood: MoodId) => void;
  rightNow: RightNowState;
}

/**
 * The check-in: the mood question and the one thing to do next, as ONE
 * surface, because they are one action - answer, then act. Side by side on
 * desktop with a hairline between them; the answer stacks under the
 * question on smaller screens.
 */
export function HubHero({ mood, onMoodChange, rightNow }: HubHeroProps) {
  return (
    <div className='grid gap-6 rounded-2xl bg-card/70 p-6 shadow-elevation-1 backdrop-blur-sm dark:bg-card lg:grid-cols-[minmax(0,1fr)_22rem] lg:gap-0 lg:p-8'>
      <div className='lg:pr-8'>
        <MoodStrip value={mood} onChange={onMoodChange} />
      </div>
      <div className='border-t border-border/60 pt-6 lg:border-l lg:border-t-0 lg:pl-8 lg:pt-0'>
        <RightNow state={rightNow} />
      </div>
      {/* Full width, so it reads as one line: an open door, not a panel. */}
      {offersSupport(rightNow) && (
        <SupportPrompt className='lg:col-span-2 lg:mt-6' />
      )}
    </div>
  );
}
